/* tslint:disable */
/* eslint-disable */
/**
 * Public Track API
 * Public Track APIs provide customers access to their SPiDRs, Security Focuses and SPiDR Blueprints
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { AttachmentUrlFromJSON, BlueprintWithOrganizationDataFromJSON, OrganizationFromJSON, SecurityFocusEventsFromJSON, SecurityFocusFullFromJSON, SecurityFocusWithStateChangeTimeFromJSON, SpidrBlueprintFavouriteFromJSON, SpidrFrameworkCategoriesFromJSON, SpidrImprovementsInputToJSON, SpidrRatingInputToJSON, SpidrSummaryFromJSON, SpidrWithFocusFromJSON, } from '../models';
/**
 *
 */
export class DefaultApi extends runtime.BaseAPI {
    /**
     */
    createSpidrBlueprintFavouriteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.orgID === null || requestParameters.orgID === undefined) {
                throw new runtime.RequiredError('orgID', 'Required parameter requestParameters.orgID was null or undefined when calling createSpidrBlueprintFavourite.');
            }
            if (requestParameters.spidrBlueprintID === null || requestParameters.spidrBlueprintID === undefined) {
                throw new runtime.RequiredError('spidrBlueprintID', 'Required parameter requestParameters.spidrBlueprintID was null or undefined when calling createSpidrBlueprintFavourite.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/v1/organizations/{orgID}/spidr-blueprints/{spidrBlueprintID}/favourites`.replace(`{${"orgID"}}`, encodeURIComponent(String(requestParameters.orgID))).replace(`{${"spidrBlueprintID"}}`, encodeURIComponent(String(requestParameters.spidrBlueprintID))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SpidrBlueprintFavouriteFromJSON(jsonValue));
        });
    }
    /**
     */
    createSpidrBlueprintFavourite(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.createSpidrBlueprintFavouriteRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    deleteSpidrBlueprintFavouriteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.orgID === null || requestParameters.orgID === undefined) {
                throw new runtime.RequiredError('orgID', 'Required parameter requestParameters.orgID was null or undefined when calling deleteSpidrBlueprintFavourite.');
            }
            if (requestParameters.spidrBlueprintID === null || requestParameters.spidrBlueprintID === undefined) {
                throw new runtime.RequiredError('spidrBlueprintID', 'Required parameter requestParameters.spidrBlueprintID was null or undefined when calling deleteSpidrBlueprintFavourite.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/v1/organizations/{orgID}/spidr-blueprints/{spidrBlueprintID}/favourites`.replace(`{${"orgID"}}`, encodeURIComponent(String(requestParameters.orgID))).replace(`{${"spidrBlueprintID"}}`, encodeURIComponent(String(requestParameters.spidrBlueprintID))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     */
    deleteSpidrBlueprintFavourite(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteSpidrBlueprintFavouriteRaw(requestParameters, initOverrides);
        });
    }
    /**
     */
    getOrganizationRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.orgID === null || requestParameters.orgID === undefined) {
                throw new runtime.RequiredError('orgID', 'Required parameter requestParameters.orgID was null or undefined when calling getOrganization.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/v1/organizations/{orgID}`.replace(`{${"orgID"}}`, encodeURIComponent(String(requestParameters.orgID))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => OrganizationFromJSON(jsonValue));
        });
    }
    /**
     */
    getOrganization(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getOrganizationRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    getOrganizationSecurityFocusRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.orgID === null || requestParameters.orgID === undefined) {
                throw new runtime.RequiredError('orgID', 'Required parameter requestParameters.orgID was null or undefined when calling getOrganizationSecurityFocus.');
            }
            if (requestParameters.focusID === null || requestParameters.focusID === undefined) {
                throw new runtime.RequiredError('focusID', 'Required parameter requestParameters.focusID was null or undefined when calling getOrganizationSecurityFocus.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/v1/organizations/{orgID}/security-focuses/{focusID}`.replace(`{${"orgID"}}`, encodeURIComponent(String(requestParameters.orgID))).replace(`{${"focusID"}}`, encodeURIComponent(String(requestParameters.focusID))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SecurityFocusFullFromJSON(jsonValue));
        });
    }
    /**
     */
    getOrganizationSecurityFocus(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getOrganizationSecurityFocusRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    getOrganizationSecurityFocusEventsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.orgID === null || requestParameters.orgID === undefined) {
                throw new runtime.RequiredError('orgID', 'Required parameter requestParameters.orgID was null or undefined when calling getOrganizationSecurityFocusEvents.');
            }
            if (requestParameters.focusID === null || requestParameters.focusID === undefined) {
                throw new runtime.RequiredError('focusID', 'Required parameter requestParameters.focusID was null or undefined when calling getOrganizationSecurityFocusEvents.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/v1/organizations/{orgID}/security-focuses/{focusID}/events`.replace(`{${"orgID"}}`, encodeURIComponent(String(requestParameters.orgID))).replace(`{${"focusID"}}`, encodeURIComponent(String(requestParameters.focusID))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SecurityFocusEventsFromJSON(jsonValue));
        });
    }
    /**
     */
    getOrganizationSecurityFocusEvents(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getOrganizationSecurityFocusEventsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    getOrganizationSecurityFocusesRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.orgID === null || requestParameters.orgID === undefined) {
                throw new runtime.RequiredError('orgID', 'Required parameter requestParameters.orgID was null or undefined when calling getOrganizationSecurityFocuses.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/v1/organizations/{orgID}/security-focuses`.replace(`{${"orgID"}}`, encodeURIComponent(String(requestParameters.orgID))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SecurityFocusWithStateChangeTimeFromJSON));
        });
    }
    /**
     */
    getOrganizationSecurityFocuses(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getOrganizationSecurityFocusesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    getOrganizationSpidrRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.orgID === null || requestParameters.orgID === undefined) {
                throw new runtime.RequiredError('orgID', 'Required parameter requestParameters.orgID was null or undefined when calling getOrganizationSpidr.');
            }
            if (requestParameters.spidrID === null || requestParameters.spidrID === undefined) {
                throw new runtime.RequiredError('spidrID', 'Required parameter requestParameters.spidrID was null or undefined when calling getOrganizationSpidr.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/v1/organizations/{orgID}/spidrs/{spidrID}`.replace(`{${"orgID"}}`, encodeURIComponent(String(requestParameters.orgID))).replace(`{${"spidrID"}}`, encodeURIComponent(String(requestParameters.spidrID))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SpidrWithFocusFromJSON(jsonValue));
        });
    }
    /**
     */
    getOrganizationSpidr(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getOrganizationSpidrRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    getOrganizationSpidrAttachmentLinkRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.orgID === null || requestParameters.orgID === undefined) {
                throw new runtime.RequiredError('orgID', 'Required parameter requestParameters.orgID was null or undefined when calling getOrganizationSpidrAttachmentLink.');
            }
            if (requestParameters.spidrID === null || requestParameters.spidrID === undefined) {
                throw new runtime.RequiredError('spidrID', 'Required parameter requestParameters.spidrID was null or undefined when calling getOrganizationSpidrAttachmentLink.');
            }
            if (requestParameters.attachmentID === null || requestParameters.attachmentID === undefined) {
                throw new runtime.RequiredError('attachmentID', 'Required parameter requestParameters.attachmentID was null or undefined when calling getOrganizationSpidrAttachmentLink.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/v1/organizations/{orgID}/spidrs/{spidrID}/attachments/{attachmentID}`.replace(`{${"orgID"}}`, encodeURIComponent(String(requestParameters.orgID))).replace(`{${"spidrID"}}`, encodeURIComponent(String(requestParameters.spidrID))).replace(`{${"attachmentID"}}`, encodeURIComponent(String(requestParameters.attachmentID))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => AttachmentUrlFromJSON(jsonValue));
        });
    }
    /**
     */
    getOrganizationSpidrAttachmentLink(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getOrganizationSpidrAttachmentLinkRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    getOrganizationSpidrBlueprintsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.orgID === null || requestParameters.orgID === undefined) {
                throw new runtime.RequiredError('orgID', 'Required parameter requestParameters.orgID was null or undefined when calling getOrganizationSpidrBlueprints.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/v1/organizations/{orgID}/spidr-blueprints`.replace(`{${"orgID"}}`, encodeURIComponent(String(requestParameters.orgID))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BlueprintWithOrganizationDataFromJSON));
        });
    }
    /**
     */
    getOrganizationSpidrBlueprints(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getOrganizationSpidrBlueprintsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    getOrganizationSpidrSummaryRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.orgID === null || requestParameters.orgID === undefined) {
                throw new runtime.RequiredError('orgID', 'Required parameter requestParameters.orgID was null or undefined when calling getOrganizationSpidrSummary.');
            }
            if (requestParameters.spidrID === null || requestParameters.spidrID === undefined) {
                throw new runtime.RequiredError('spidrID', 'Required parameter requestParameters.spidrID was null or undefined when calling getOrganizationSpidrSummary.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/v1/organizations/{orgID}/spidrs/{spidrID}/summary`.replace(`{${"orgID"}}`, encodeURIComponent(String(requestParameters.orgID))).replace(`{${"spidrID"}}`, encodeURIComponent(String(requestParameters.spidrID))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SpidrSummaryFromJSON(jsonValue));
        });
    }
    /**
     */
    getOrganizationSpidrSummary(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getOrganizationSpidrSummaryRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * return a object of lists that are subCategories from the spidr framework
     */
    getSpidrFrameworkCategoriesRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/api/v1/spidr-framework-categories`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SpidrFrameworkCategoriesFromJSON(jsonValue));
        });
    }
    /**
     * return a object of lists that are subCategories from the spidr framework
     */
    getSpidrFrameworkCategories(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getSpidrFrameworkCategoriesRaw(initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    updateOrganizationSpidrImprovementsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.orgID === null || requestParameters.orgID === undefined) {
                throw new runtime.RequiredError('orgID', 'Required parameter requestParameters.orgID was null or undefined when calling updateOrganizationSpidrImprovements.');
            }
            if (requestParameters.spidrID === null || requestParameters.spidrID === undefined) {
                throw new runtime.RequiredError('spidrID', 'Required parameter requestParameters.spidrID was null or undefined when calling updateOrganizationSpidrImprovements.');
            }
            if (requestParameters.ifMatch === null || requestParameters.ifMatch === undefined) {
                throw new runtime.RequiredError('ifMatch', 'Required parameter requestParameters.ifMatch was null or undefined when calling updateOrganizationSpidrImprovements.');
            }
            if (requestParameters.spidrImprovementsInput === null || requestParameters.spidrImprovementsInput === undefined) {
                throw new runtime.RequiredError('spidrImprovementsInput', 'Required parameter requestParameters.spidrImprovementsInput was null or undefined when calling updateOrganizationSpidrImprovements.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.ifMatch !== undefined && requestParameters.ifMatch !== null) {
                headerParameters['If-Match'] = String(requestParameters.ifMatch);
            }
            const response = yield this.request({
                path: `/api/v1/organizations/{orgID}/spidrs/{spidrID}/improvements`.replace(`{${"orgID"}}`, encodeURIComponent(String(requestParameters.orgID))).replace(`{${"spidrID"}}`, encodeURIComponent(String(requestParameters.spidrID))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: SpidrImprovementsInputToJSON(requestParameters.spidrImprovementsInput),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SpidrWithFocusFromJSON(jsonValue));
        });
    }
    /**
     */
    updateOrganizationSpidrImprovements(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateOrganizationSpidrImprovementsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     */
    updateOrganizationSpidrRatingRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.orgID === null || requestParameters.orgID === undefined) {
                throw new runtime.RequiredError('orgID', 'Required parameter requestParameters.orgID was null or undefined when calling updateOrganizationSpidrRating.');
            }
            if (requestParameters.spidrID === null || requestParameters.spidrID === undefined) {
                throw new runtime.RequiredError('spidrID', 'Required parameter requestParameters.spidrID was null or undefined when calling updateOrganizationSpidrRating.');
            }
            if (requestParameters.ifMatch === null || requestParameters.ifMatch === undefined) {
                throw new runtime.RequiredError('ifMatch', 'Required parameter requestParameters.ifMatch was null or undefined when calling updateOrganizationSpidrRating.');
            }
            if (requestParameters.spidrRatingInput === null || requestParameters.spidrRatingInput === undefined) {
                throw new runtime.RequiredError('spidrRatingInput', 'Required parameter requestParameters.spidrRatingInput was null or undefined when calling updateOrganizationSpidrRating.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.ifMatch !== undefined && requestParameters.ifMatch !== null) {
                headerParameters['If-Match'] = String(requestParameters.ifMatch);
            }
            const response = yield this.request({
                path: `/api/v1/organizations/{orgID}/spidrs/{spidrID}/rating`.replace(`{${"orgID"}}`, encodeURIComponent(String(requestParameters.orgID))).replace(`{${"spidrID"}}`, encodeURIComponent(String(requestParameters.spidrID))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: SpidrRatingInputToJSON(requestParameters.spidrRatingInput),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SpidrWithFocusFromJSON(jsonValue));
        });
    }
    /**
     */
    updateOrganizationSpidrRating(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.updateOrganizationSpidrRatingRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
